export const MessageUserRole = {
    LEARNER: 'LEARNER',
    THIRD_PARTY: 'THIRD_PARTY'
};

export const MessagePageLocation = {
    REGISTRATION_REGISTER: 'REGISTRATION.REGISTER',
    REGISTRATION_SIGN_IN: 'REGISTRATION.SIGN_IN'
};

export const MessageDisplayType = {
    BANNER: 'banner',
    ALERT: 'alert'
};

export const MessageContext = {
    ALERT: 'ALERT',
    NOTICE: 'NOTICE',
    SIMPLE: 'SIMPLE'
};

export const MessageBannerContext = {
    WARNING: 'warning',
    LIGHT: 'light',
    DARK: 'dark'
};
